import React, { Component } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import "./LoadingContent.css";

export default class LoadingContent extends Component {

    render() {
        return (
            <div className="LoadingContent">
                <Grid container direction="column"  justifyContent="flex-end" alignItems="center">
                    <CircularProgress/>
                </Grid>
            </div>
        )
    }

}